import api from './api';
import { NotificationListResponse } from '../types/notification';

export const notificationService = {
  async list(): Promise<NotificationListResponse> {
    const response = await api.get<NotificationListResponse>('/notifications');
    return response.data;
  },
  async markRead(id: string): Promise<void> {
    await api.post(`/notifications/${id}/read`);
  },
  async markAllRead(): Promise<void> {
    await api.post('/notifications/read-all');
  },
};
